import { Select, Option } from 'kpc/components/select';
import { Vue, Component, PropSync, Watch, Prop } from 'vue-property-decorator'

import {debounce} from 'helpful-decorators'
import { isArray } from 'lodash';

@Component({
    components: {
        Select,
        Option
    }
})
export default class KsSelect extends Vue {

    selectData: any = []
    
    @Prop({
        required: true
    })
    selected !: any
        
    @Prop({
        required: true,
    })
    selectList !: any

    @Prop({
        required: false,
        default: false
    })
    disabled !: any;

    @Prop({
        required: false,
    })
    placeholder !: string

    @Watch('selectData')
    selectDataWatcher(val: any) {
        let tempList = val;
        console.log(val)
        if (tempList && isArray(tempList) && tempList.length) {
            if (tempList[tempList.length - 1].includes(',')) {
                const portList = tempList.pop()
                tempList.push(...portList.trim().split(','))
            }
        }
        this.$emit('changeSelect', tempList);
    }

    keyUpEnter() {
        (this.$refs.select as any)._onBlur();
    }

    created() {
        if (this.selected) {
            this.selectData = this.selected;
        }   
    }
}


